import { render, staticRenderFns } from "./SetColorToLessons.vue?vue&type=template&id=1069fec2"
import script from "./SetColorToLessons.vue?vue&type=script&lang=js"
export * from "./SetColorToLessons.vue?vue&type=script&lang=js"
import style0 from "./SetColorToLessons.vue?vue&type=style&index=0&id=1069fec2&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1069fec2')) {
      api.createRecord('1069fec2', component.options)
    } else {
      api.reload('1069fec2', component.options)
    }
    module.hot.accept("./SetColorToLessons.vue?vue&type=template&id=1069fec2", function () {
      api.rerender('1069fec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SetColorToLessons.vue"
export default component.exports